<div class="chat-panel-container">
  <!-- Header -->
  <!-- <div class="chat-header"> -->
    <!-- <img src="/assets/image.png" alt="Logo" style="height: 40px; margin-right: 0.5rem;"> -->
    <!-- <button class="new-session-button" (click)="startNewSession()">
      + New session
    </button>
  </div> -->

  <div class="chat-header">
    <button class="new-session-button" (click)="startNewSession()">
      + New Chat
    </button>

    <!-- 🌙 Theme Toggle Button -->
    <!-- <button class="theme-toggle-btn" mat-icon-button (click)="toggleTheme()" matTooltip="Toggle theme">
      <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button> -->
  </div>

  <!-- Message Area -->
  <div class="chat-body" #chatBody>
    <div class="messages-container">
      <div *ngFor="let msg of messages" class="message-row" [ngClass]="{'message-row-user': msg.sender === 'user', 'message-row-agent': msg.sender === 'agent', 'message-row-with-options': msg.type === 'option', 'message-row-json': msg.type === 'json'}">
        <!-- Agent Avatar -->
        <div *ngIf="msg.sender === 'agent'" class="agent-avatar">A</div>
        
        <div class="message-bubble" [ngClass]="msg.sender === 'user' ? 'user-message' : 'agent-message'">
          <div class="message-content" *ngIf="!msg.type || msg.type === 'option'">
            <app-streaming-text *ngIf="msg.sender === 'agent'" [content]="msg.formattedText || msg.text"></app-streaming-text>
            <div *ngIf="msg.sender === 'user'" [innerHTML]="msg.formattedText || msg.text"></div>
            <div *ngIf="msg.loading" class="loader"></div>
            <mat-icon *ngIf="msg.completed" class="completed-icon">check_circle</mat-icon>
          </div>
          <app-dynamic-edit-table *ngIf="msg.type === 'table'" [data]="msg.data" [isChat]="true"></app-dynamic-edit-table>
          <div *ngIf="msg.type === 'json'" class="json-container">
            <textarea class="json-editor" [(ngModel)]="msg.rawJson" readonly></textarea>
            <button class="copy-json-button" (click)="copyJson(msg)" matTooltip="Copy JSON">
              <mat-icon>content_copy</mat-icon>
            </button>
            <span *ngIf="msg.copied" class="copy-success-message">Copied to clipboard!</span>
          </div>

          <!-- Attached files shown in sent messages -->
          <div *ngIf="msg.files?.length" class="attached-files">
            <div *ngFor="let file of msg.files" class="attached-file">
              <mat-icon>attach_file</mat-icon>
              <span>{{ file.name }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="msg.type === 'option'" class="options-container">
          <button *ngFor="let option of msg.data" class="chat-option-button" (click)="onOptionSelected(option.key)">
            {{ option.label }}
          </button>
        </div>
      </div>

      <!-- Typing Indicator -->
      <div *ngIf="isLoading" class="message-row message-row-agent">
        <div class="message-bubble agent-message typing-indicator">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Input Area -->
  <div class="chat-footer">
    <div class="input-container">
      <div class="input-wrapper">
        <!-- Upload Icon inside the input box -->
        <label class="upload-icon" matTooltip="Upload file">
          <input type="file" multiple (change)="onFileSelected($event)" hidden />
          <mat-icon>attach_file</mat-icon>
        </label>

        <!-- File Previews + Message Input -->
        <div class="input-content">
          <!-- Uploaded files shown above the text -->
          <div *ngIf="selectedFiles.length > 0" class="file-chips">
            <div *ngFor="let file of selectedFiles" class="file-chip">
              <mat-icon>insert_drive_file</mat-icon>
              <span>{{ file.name }}</span>
              <button mat-icon-button (click)="removeFile(file)" matTooltip="Remove">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Multi-line message input -->
          <textarea class="chat-input" placeholder="Type a message..." [(ngModel)]="currentMessage"
            (keyup.enter)="sendMessageOnEnter($event)" [disabled]="isLoading" rows="1"></textarea>
        </div>

      </div>

      <!-- Send Button -->
      <button class="send-btn" (click)="sendMessage()" mat-icon-button [disabled]="isLoading">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>